import tinycolor from 'tinycolor2'

export const isDarkColor = (color?: string) => {
  return tinycolor(color).isDark()
}

export const parseColorToRgb = (color?: string) => {
  return tinycolor(color).toRgb()
}

export const parseColorToRgbString = (color?: string) => {
  return tinycolor(color).toRgbString()
}

export const parseColorToHex = (color?: string) => {
  return tinycolor(color).toHex()
}
